import React, { Component, Fragment } from 'react';
import moment from 'moment';
import { NavLink } from 'react-router-dom';

const Order = ({ order, orderStatus, isPlantUser, onShipmentClick, changeStatusFromReceivedToShipped, handleDelete, isDeliveryUser }) => {
  const sentDate = order ? moment(order.sent_to_market_date).format('L') : '';
  const deliveryDate = order && order.delivery_date ? moment(order.delivery_date).format('L') : '-';
  const shipmentDate = order && order.shipment_date ? moment(order.shipment_date).format('L') : '-';
  const hasPendingItems = order && order.has_pending_items;
  return(
    <tr>
      <td className={(isPlantUser || isDeliveryUser) && "hidden-xs-down"}>{order ? order.id : ''}</td>
      {(isPlantUser || isDeliveryUser)  && <td>{order ? order.market.name : ''}</td>}
      <td>{isPlantUser ? sentDate : deliveryDate}</td>
      {!isPlantUser && <td className="hidden-xs-down">{shipmentDate}</td>}
      <td className="hidden-xs-down">{
        isPlantUser ? deliveryDate : order.num_items}</td>
      {!isDeliveryUser && (
        <td className={isPlantUser && "hidden-xs-down"}>
          <span className={`badge badge-pill custom-badge ${orderStatus.badgeClass}`}>{orderStatus.name}</span>
        </td>
      )}
      {!isDeliveryUser && <td className="hidden-xs-down">{order ? order.created_by.username : ''}</td>}
      <td>
        <span className="d-flex">
        {order.status === 1 && isPlantUser && (
          <button
            className="mr-05 btn-sm btn-primary btn"
            onClick={() => onShipmentClick(order.id, order.shipment)}
          >
            <i className="fa fa-truck"></i>
          </button>
        )}
        {order.status > 0 ?
          <Fragment>
            <NavLink className="btn-sm btn-primary hidden-xs-down" to={`/orders/${order.id}`}>
              <i className="fa fa-eye"></i>
            </NavLink>
            {order.status === 3 && hasPendingItems && !isPlantUser && (
              <span className="ml-05 btn btn-sm btn-primary mr-0 hidden-xs-down" onClick={changeStatusFromReceivedToShipped}>
                <i className="fa fa-qrcode"></i>
              </span>
            )}
            <div className="d-flex flex-column hidden-sm-up">
              <NavLink className="btn btn-sm btn-primary" to={`/orders/${order.id}`}>
                <i className="fa fa-eye"></i>
              </NavLink>
              {order.status === 3 && hasPendingItems && !isPlantUser && (
                <span className="mt-05 btn btn-sm btn-primary" onClick={changeStatusFromReceivedToShipped}>
                  <i className="fa fa-qrcode"></i>
                </span>
              )}
            </div>
          </Fragment>
        :
          <NavLink className="btn-sm btn-primary" to={`/orders/${order.id}`}>
            <i className="fa fa-edit "></i>
          </NavLink>
        }
        {order.status === 1 && isPlantUser && (
          <span className="ml-05 btn btn-sm btn-danger mr-0" onClick={handleDelete}>
            <i className="fa fa-trash"></i>
          </span>
        )}
        </span>
      </td>
    </tr>
  )
}

export default class MarketOrderList extends Component {
  render() {
    const {
      orders,
      orderStatusOptions,
      isPlantUser,
      onShipmentClick,
      handleDelete,
      isDeliveryUser,
      changeStatusFromReceivedToShipped,
    } = this.props;
    return (
      <tbody>
        {orders.map((order) => {
          return (
            <Order
              order={order}
              orderStatus={orderStatusOptions[order.status]}
              isPlantUser={isPlantUser}
              isDeliveryUser={isDeliveryUser}
              onShipmentClick={onShipmentClick}
              changeStatusFromReceivedToShipped={() => changeStatusFromReceivedToShipped(order.id)}
              handleDelete={() => handleDelete(order.id)}
              key={order.id}
            />
          );
        })}
      </tbody>
    );
  }
}
